import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-wrap: wrap;\n  margin: 18px 0 12px 0;\n'], ['\n  display: flex;\n  flex-wrap: wrap;\n  margin: 18px 0 12px 0;\n']);

import React from 'react';
import styled from 'styled-components';
import { DatePickerButton } from '../../../../..';

import { styles, translations } from 'gipsy-misc';

import { Options } from '../utils';

var Container = styled.div(_templateObject);

var OPTIONS = [Options.Daily, Options.Weekly, Options.Monthly, Options.Yearly];

var ScheduleSelector = function ScheduleSelector(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      readOnly = _ref.readOnly;

  var contents = void 0;
  if (readOnly) {
    contents = React.createElement(
      'span',
      null,
      translations.taskPanel.recurrency.schedule,
      ': ',
      translations.taskPanel.recurrency[value]
    );
  } else {
    contents = OPTIONS.map(function (o) {
      return React.createElement(
        DatePickerButton,
        {
          key: o,
          onClick: function onClick() {
            return onChange(o);
          },
          textColor: value === o ? 'white' : styles.colors.textLightColor,
          backgroundColor: value === o ? styles.colors.darkGrey : styles.colors.lightGrey },
        translations.taskPanel.recurrency[o]
      );
    });
  }
  return React.createElement(
    Container,
    null,
    contents
  );
};

export default ScheduleSelector;
//# sourceMappingURL=ScheduleSelector.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/TaskPanel/fields/When/RecurrencyDetails/components/ScheduleSelector.js
// module id = 1099
// module chunks = 0